<template>
  <div class="modal">
    <div class="modal__inner">
      <h1>Вы стоите на пороге<br />мира PlayStation 5</h1>
      <p data-primary>
        Тут вы столкнетесь с каноничными персонажами эксклюзивов PlayStation,
        узнаете о возможностях новой консоли и сможете получить награду в свой
        профиль на Пикабу (если, конечно, откроете секретный трофей).
      </p>
      <div class="modal__actions">
        <button
          type="button"
          data-size="big"
          class="button button--white"
          @click="startWithSound(true)"
          :data-pixel="pixels.soundOn"
        >
          Начать со звуком
        </button>
        <button
          type="button"
          data-size="big"
          class="button button--primary"
          @click="startWithSound(false)"
          :data-pixel="pixels.soundOff"
        >
          Начать без звука
        </button>
      </div>
      <div class="blue-bubble">
        <p>
          Настоящая дверь в мир развлечений открывается с
          <a :href="links.ps | randomizeLink" target="_blank"
            >PlayStation&nbsp;5</a
          >: графика нового поколения, быстрые загрузки, продвинутая технология
          звука и адаптивные триггеры в новом контроллере. Подробная информация
          о консоли —
          <a :href="links.sony | randomizeLink" target="_blank"
            >на сайте официального интернет-магазина</a
          >.
        </p>
        <a
          :href="links.preorder | randomizeLink"
          target="_blank"
          class="button button--secondary"
          :style="{ padding: '0 18px' }"
        >
          Подробнее о PS5
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pixels: {
        soundOn:
          "https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=dnchq&pfb=jhiwy&pr=%random%&ptrc=b",
        soundOff:
          "https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=dnchq&pfb=jhiwx&pr=%random%&ptrc=b"
      },
      links: {
        ps:
          "https://ads.adfox.ru/260477/goLink?p1=cnpjl&p2=frfe&p5=jhixu&pr=%random%",
        sony:
          "https://ads.adfox.ru/260477/goLink?p1=cnpjl&p2=frfe&p5=jhixv&pr=%random%",
        preorder:
          "https://ads.adfox.ru/260477/goLink?p1=cnpjl&p2=frfe&p5=jhixs&pr=%random%"
      }
    };
  },
  methods: {
    startWithSound(withSound) {
      this.$store.commit("start", withSound);
      setTimeout(() => this.$store.commit("toggleModal", "intro"), 1000);
    }
  }
};
</script>

<style lang="scss" scoped>
.modal {
  position: absolute;
  z-index: 1;

  width: 100vw;
  height: 100%;
  overflow: auto;
  padding-top: 63px;

  transition: transform 1s ease-out, opacity 1s ease-out;
  z-index: 3;

  @include mobile {
    padding: 59px 15px 71px;
  }

  .modal__inner {
    color: $white;
    border: none;
    background: none;
    box-shadow: none;
    max-width: 606px;
    padding: 16px 30px;

    row-gap: 20px;

    @include mobile {
      width: 100%;
      padding: 0;
      max-width: unset;
      row-gap: 12px;
    }

    .modal__actions {
      width: 100%;
      column-gap: 17px;

      @include mobile {
        min-width: 223px;
        width: unset;
        row-gap: 5px;
        grid-auto-flow: unset;
      }
    }

    p:last-of-type {
      @include desktop {
        width: 88%;
      }
    }

    .blue-bubble {
      p:last-of-type {
        @include desktop {
          width: 100%;
        }
      }
    }

    p a {
      color: #59f1f1;
    }

    a.button {
      font-weight: initial;
    }
  }
}

.blue-bubble {
  border: 1px solid #60a5f2;
  border-radius: 5px;
  background-color: rgba(40, 46, 193, 0.8);
  padding: 30px 30px 40px 30px;
  position: relative;
  margin-top: 45px;

  .button {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: -22px;
  }

  &:before {
    content: "";
    width: 34px;
    height: 40px;
    display: block;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: -16px;
    background-image: url("../assets/img/swords-blue.svg");
  }
}

@media (max-width: 768px) {
  .blue-bubble {
    border: none;
    border-radius: 0;
    background-color: transparent;
    padding: 0;
    margin-top: 5px;

    &:before {
      display: none;
    }

    .button {
      position: relative;
      transform: none;
      bottom: auto;
      left: auto;
      max-width: 185px;
      margin: 0 auto;
      margin-top: 15px;
    }
  }
}
</style>
